import { FilterQuery } from '../types/annotation-task-detail.type';

export const effortEmojiMapping: Record<string, string> = {
  done: '🥳',
  very_high: '🤯',
  high: '🔥',
  medium: '🥵',
  low: '😎',
  very_low: '🥶',
  inactivity: '🧊',
};

export const effortEmojiTooltip: Record<string, string> = {
  done: 'Completed',
  very_high: '6+ hours',
  high: '4-6 hours',
  medium: '1-4 hours',
  low: '0-1 hours',
  very_low: 'Work done this month, not this week.',
  inactivity: 'No work this month.',
};

export const effortToEmoji = (effort: string | undefined) => {
  return effort ? effortEmojiMapping[effort] : '';
};

export const effortToTooltip = (effort: string | undefined) => {
  return effort ? effortEmojiTooltip[effort] : '';
};

export const dateConverter = (initialDate: string) => {
  const date = new Date(initialDate);
  const convertedDate =
    date.toLocaleString('en-GB', {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric',
    }) +
    ' ' +
    date.toLocaleString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    });
  return convertedDate;
};

export const formatName = (fullName: string) => {
  return fullName
    .split(' ')
    .slice(0, 2)
    .map((word) => word.charAt(0).toUpperCase())
    .join('');
};

const PAGE_SIZE = 20;

export const getSearchQuery = (
  currentPage: number,
  filterQuery?: FilterQuery,
) => ({
  page: currentPage,
  page_size: PAGE_SIZE,
  ...(filterQuery?.status
    ? { annotation_task_status: filterQuery.status }
    : {}),
  ...(filterQuery?.startDate ? { start_date: filterQuery.startDate } : {}),
  ...(filterQuery?.endDate ? { end_date: filterQuery.endDate } : {}),
  ...(filterQuery?.searchInput
    ? { input_search: filterQuery.searchInput }
    : {}),
  ...(filterQuery?.selectedAnnotators &&
  filterQuery.selectedAnnotators.length > 0
    ? { annotator_ids: filterQuery.selectedAnnotators }
    : {}),
  ...(filterQuery?.selectedGrids && filterQuery.selectedGrids.length > 0
    ? { grid_names: filterQuery.selectedGrids }
    : {}),
  ...(filterQuery?.selectedEfforts && filterQuery.selectedEfforts.length > 0
    ? { efforts: filterQuery.selectedEfforts }
    : {}),
});

export const getStartOfWeek = (date: Date): Date => {
  const startOfWeek = new Date(date.setUTCHours(0, 0, 0, 0));
  const day = startOfWeek.getDay();
  const diff = startOfWeek.getDate() - day + (day === 0 ? -6 : 1);
  startOfWeek.setDate(diff);
  return startOfWeek;
};

export const getEndOfWeek = (startOfWeek: Date): Date => {
  const endOfWeek = new Date(startOfWeek);
  endOfWeek.setDate(endOfWeek.getDate() + 6);
  return endOfWeek;
};

export const secondsToTime = (seconds: number) => {
  const h = Math.floor(seconds / 3600)
      .toString()
      .padStart(2, '0'),
    m = Math.floor((seconds % 3600) / 60)
      .toString()
      .padStart(2, '0'),
    s = Math.floor(seconds % 60)
      .toString()
      .padStart(2, '0');

  return h + ':' + m + ':' + s;
};
